import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as AppState from "../state";
import { featureKey, State } from "./policy.reducer";

const selectFeatureState = createFeatureSelector<AppState.State, State>(
  featureKey
);

export const selectPolicies = createSelector(
  selectFeatureState,
  (state) => state.policies
);

export const selectFuturePolicies = createSelector(selectPolicies, (policies) =>
  policies.filter((p) => p.futurePolicy === true)
);

export const selectPresentPolicies = createSelector(
  selectPolicies,
  (policies) =>
    policies.filter(
      (p) => p.filterCancelled !== true && p.futurePolicy !== true
    )
);
